import React from 'react';
import { CircularProgress } from '@mui/material';
import { CustomButton } from './CustomComponents';

interface LoadingButtonProps extends React.ComponentProps<typeof CustomButton> {
  loading?: boolean;
}

function LoadingButton({
  loading = false,
  children,
  disabled,
  fullWidth,
  type,
  variant,
  disableElevation,
  onClick,
  sx,
  size,
  className,
  href,
  id,
}: LoadingButtonProps): React.ReactElement {
  return (
    <CustomButton
      fullWidth={fullWidth}
      type={type}
      variant={variant}
      disableElevation={disableElevation}
      onClick={onClick}
      sx={sx}
      size={size}
      className={className}
      href={href}
      id={id}
      disabled={disabled ?? loading}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : children}
    </CustomButton>
  );
}

LoadingButton.defaultProps = {
  loading: false,
};

export default LoadingButton;
